module.exports = __webpack_public_path__ + "static/media/YF09_3.b71a4e36.jpg";